import { TutorialProvider, Tutorials } from './../../providers/tutorial/tutorial';
import { Component, OnInit } from '@angular/core';

import { ConfigProvider } from '../../providers/config/config';
import { App } from 'ionic-angular';
import { AdsProvider } from '../../providers/ads/ads';
import { AppDetectorProvider } from '../../providers/detector/detector';

@Component({
  selector: 'tutorials',
  templateUrl: 'tutorials.component.html'
})
export class TutorialsComponent implements OnInit{
  isEnabled: boolean = false;
  tutorials: Tutorials;
  currentTutorialIndex: number = 0;

  constructor(
    private config: ConfigProvider,
    private tutorialProvider: TutorialProvider,
    private app: App,
    private ads:AdsProvider,
    private appDetector: AppDetectorProvider
    ) { 
    }

  async ngOnInit(){
    if(window.screen.width>600){
      this.tutorialProvider.isLoginAllowed = true;
      return
    }
    this.tutorials = (await this.config.config).showHide.tutorials || {
      isEnabled: false,
      size: 0
    };

    this.tutorialProvider.isFirstRun("tutorials").then(isFirstRun => {
      this.isEnabled = isFirstRun && this.tutorials.isEnabled;
      if(this.isEnabled){
        this.tutorialProvider.isLoginAllowed = false;
      }
    });
  }
  onTapTutorial(){
    this.currentTutorialIndex++;
    let tutorialPage = this.tutorials.tabIndex[this.currentTutorialIndex];
    if (this.currentTutorialIndex >= this.tutorials.size) {
      this.isEnabled = false;
      this.tutorialProvider.isLoginAllowed = true;
      this.tutorialProvider.setTutorialDone("tutorials");
      this.app.getRootNav().getActiveChildNav().select(0);
      return;
    }
    this.app.getRootNav().getActiveChildNav().select(tutorialPage);
  }
  ionViewDidLeave(){
    this.ads.show();
  }
}




// WEBPACK FOOTER //
// /src/components/tutorials/tutorials.component.ts